import { styled } from '@mui/material'
import Chip from '@mui/material/Chip'
import Box from '@mui/material/Box'
import { Typography } from '@mui/material'
import { ClearRounded } from '@mui/icons-material'
import { declination } from 'utils/declination'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'

const formatValue = ({ value, type }) => {
  if (type === 'range') return value.map(({ value }) => value).join('-')

  if (type === 'text') return value

  return Array.isArray(value)
    ? value.length > 1
      ? `${value.length} ${declination(value.length, ['выбран', 'выбрано', 'выбрано'])}`
      : value[0]?.label || value[0]
    : value.label
}

const formatTooltipValue = ({ value, type }) => {
  if (type === 'range') return null

  if (Array.isArray(value) && value.length > 1) {
    return value.map(({ label }) => label).join(', ')
  }

  return null
}

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.vars.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.vars.palette.common.white,
  },
}))

const StyledChip = styled(Chip)(() => ({
  height: '3.2rem',
  borderRadius: '0.8rem',
  backgroundColor: 'chipBackground',
}))

function FilterTag({ filter, setQuery }) {
  const handleDelete = () => {
    setQuery((query) => ({ ...query, [filter.name]: undefined }))
  }

  return (
    <StyledTooltip title={formatTooltipValue(filter)} arrow>
      <StyledChip
        onDelete={handleDelete}
        deleteIcon={<ClearRounded fontSize="small" />}
        label={
          <Box component="span">
            <Typography
              variant="caption"
              sx={{ opacity: 0.6, width: 'max-content' }}
            >
              {`${filter.label}:`}
            </Typography>{' '}
            <Typography variant="caption" sx={{ width: 'max-content' }}>
              {formatValue(filter)}
            </Typography>
          </Box>
        }
      ></StyledChip>
    </StyledTooltip>
  )
}

export default FilterTag
